exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".control-label {\r\n  font-size: small;\r\n}\r\n\r\n.example-color {\r\n  color: #b4b4b4;\r\n}\r\n\r\n.active-staus {\r\n  color: white;\r\n  background-color: #5cb85c;\r\n}\r\n\r\n.inactive-staus {\r\n  color: white;\r\n  background-color: #d9534f;\r\n}\r\n\r\n.dropdown-menu {\r\n  max-height: 300px;\r\n  overflow-y: scroll;\r\n}\r\n\r\n.component-background {\r\n  overflow: unset;\r\n}\r\n\r\n.custom-alert {\r\n  padding: 7px;\r\n  margin: 0;\r\n  background-color: rgba(150, 200, 249, 0.11);\r\n  color: #434343;\r\n}\r\n\r\n.box-title {\r\n  border: 1px solid rgba(158, 158, 158, 0.97);\r\n  border-radius: 4px;\r\n  display: inline-block;\r\n  background-color: rgba(150, 200, 249, 0.11);\r\n  padding: 4px 24px;\r\n}\r\n\r\n.box-title-star {\r\n  border: 1px solid rgba(150, 200, 249, 0.14);\r\n  border-radius: 4px;\r\n  display: inline-block;\r\n  background-color: rgba(150, 200, 249, 0.14);\r\n  padding: 4px 12px;\r\n  color: #000000;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/admin/create-user/create-user.component.css
// module id = ../../../../../src/app/content-page/admin/create-user/create-user.component.css
// module chunks = main